import { Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import GroupIcon from "@mui/icons-material/Group";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import VerifiedIcon from "@mui/icons-material/Verified";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { formatInteger, formatPercent } from "../formatters";

const PRIMARY = "#8E24AA";

interface UsersKpiCardsProps {
  total: number;
  leads: number;
  qualified: number;
}

export default function UsersKpiCards({ total, leads, qualified }: UsersKpiCardsProps) {
  const conversion = total ? (qualified / total) * 100 : 0;

  return (
    <Grid container spacing={2.5}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1 }}>
              TOTAL USERS
            </Typography>
            <GroupIcon sx={{ color: PRIMARY }} />
          </Stack>
          <Typography variant="h5" fontWeight={700} sx={{ mt: 1, fontSize: 30, color: "#1a1a1a" }}>
            {formatInteger(total)}
          </Typography>
          <Typography variant="caption" sx={{ color: "#9e9e9e", fontSize: 12, display: "block", mt: 0.25 }}>
            entered the funnel
          </Typography>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1 }}>
              LEADS
            </Typography>
            <HowToRegIcon sx={{ color: "#5B9BD5" }} />
          </Stack>
          <Typography variant="h5" fontWeight={700} sx={{ mt: 1, fontSize: 30, color: "#1a1a1a" }}>
            {formatInteger(leads)}
          </Typography>
          <Typography variant="caption" sx={{ color: "#9e9e9e", fontSize: 12, display: "block", mt: 0.25 }}>
            completed contact details
          </Typography>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1 }}>
              QUALIFIED
            </Typography>
            <VerifiedIcon sx={{ color: "#2E7D32" }} />
          </Stack>
          <Typography variant="h5" fontWeight={700} sx={{ mt: 1, fontSize: 30, color: "#1a1a1a" }}>
            {formatInteger(qualified)}
          </Typography>
          <Typography variant="caption" sx={{ color: "#9e9e9e", fontSize: 12, display: "block", mt: 0.25 }}>
            met all criteria
          </Typography>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1 }}>
              CONVERSION
            </Typography>
            <TrendingFlatIcon sx={{ color: PRIMARY }} />
          </Stack>
          <Typography variant="h5" fontWeight={700} sx={{ mt: 1, fontSize: 30, color: "#1a1a1a" }}>
            {formatPercent(conversion, 2)}
          </Typography>
          <Typography variant="caption" sx={{ color: "#9e9e9e", fontSize: 12, display: "block", mt: 0.25 }}>
            user &rarr; qualified
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
